<template>
<!-- eslint-disable max-len -->
<div class="panel">
  <div class="header">
    {{ singlePlayer ? 'Activity' : 'Group Activity' }}
  </div>
  <div class="notification-list" id="nlist">
    <template v-for="(notification, i) in groupNotifications">
      <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp" :key="`notification-${i}`">
        <notification :notification="notification">
        </notification>
      </transition>
    </template>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

// eslint-disable-next-line no-shadow
import Notification from './Notification';

export default {
  components: {
    Notification
  },
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'groupNotifications',
      'unreadNotificationCount',
      'singlePlayer'
    ]),
  },
  methods: {
    ...mapActions([
      'setUnreadNotificationCount',
    ]),
  },
  watch: {
    unreadNotificationCount(newValue) {
      if (newValue && document.getElementById('nlist').scrollTop < 600) {
        this.setUnreadNotificationCount(0);
      }
    }
  },
  created() {
  },
  async mounted() {
    // console.log(this.groupNotifications);
    await this.setUnreadNotificationCount(0);
  }
};
</script>

<style lang="scss" scoped>
.fadeInUp {
  animation-duration: 0.8s;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}
.fadeOutUp {
  animation-duration: 0.4s;
  animation-timing-function: cubic-bezier(0.895, 0.03, 0.685, 0.22);
}

.panel {
  width: 780px;
  height: 600px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 100px black inset;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 5px;
}
.notification-list {
  width: 100%;
  height: 540px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  -webkit-overflow-scrolling: touch;
}
@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  .notification-list {
    overflow: auto;
  }
}
.header {
  width: 100%;
  height: 40px;
  font-size: 30px;
  color: white;
  font-weight: bold;
  text-align: center;
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/NotificationPanel.vue